"use client";
import Text from "../Text/index.js";
import React from "react";
import { useFormControlPrivate } from "./FormControl.context.js";
import s from "./FormControl.module.css";
const FormControlLabel = (props) => {
    const { children } = props;
    const { attributes, required, group, disabled, size } = useFormControlPrivate();
    const id = `${attributes.id}-label`;
    const tagProps = group
        ? { as: "legend", attributes: { id } }
        : {
            as: "label",
            attributes: { id, htmlFor: attributes.id },
        };
    return (React.createElement(Text, { ...tagProps, variant: size === "large" ? "body-2" : "body-3", weight: "medium", className: s.label, color: disabled ? "disabled" : undefined },
        children,
        required && (React.createElement(Text, { color: disabled ? "disabled" : "critical", as: "span" }, "*"))));
};
export default FormControlLabel;
